// Test ES6 and TypeScript transpilation.
export const browserSupportsAllFeatures = () => {
    const isIntersectionObserver = 'IntersectionObserver' in window;
    const isFetch = 'fetch' in window;
    return isIntersectionObserver && isFetch;
};